export const loginUrl="/api/auth/login";
export const signupUrl="/api/auth/signup";
export const notesUrl="/api/notes";
export const archiveUrl="/api/archives";
export const trashUrl="/api/trash";